import React, { useContext, useState } from "react";
import "./Section_Header_Bar.css";
import CircularProgress from "@mui/joy/CircularProgress";
import White_Btn from "../common_btn/white_btn/White_Btn";
import Orange_White_Border_Btn from "../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Verification_Steps_Modal from "../common_modal/verification_steps_modal/Verification_Steps_Modal";
import { Context } from "../../../utils/context";

const Section_Header_Bar = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const { userdata, getuserData, signin } = useContext(Context);


  return (
    <section className="Section_Header_Bar">
      <div className="row align-items-center">
        <div className="col-xl-8 col-lg-7">
          <div className="left_side_div">
            <div className="progeress_holder">
              <CircularProgress
                size="lg"
                determinate
                value={userdata?.accept_or_reject == true ? 100 : 80}
              >
                <span className="bold_num">
                  {userdata?.accept_or_reject == true ? 100 : 80}%
                </span>
              </CircularProgress>
            </div>
            <div className="text_holder">
              <p className="hello_text">Hello {userdata?.first_name},</p>
              <p className="sub_text">
                {userdata?.accept_or_reject == true
                  ? "Your Profile has been Accepted"
                  : "Fill in your account details to make your first Deposit."}
              </p>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-lg-5">
          <div className="btn_holder">
            <div className="learn_more_btn">
              <White_Btn
                btn_name="Learn More"
                onClick={() => {
                  navigate("/about-profile");
                }}
              />
            </div>

            {userdata?.accept_or_reject == false && (
              <div className="complete_more_btn">
                <Orange_White_Border_Btn
                  btn_name="Complete Profile"
                  onClick={() => {
                    setShowModal(true);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <Verification_Steps_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default Section_Header_Bar;
